"use client";

import { ActivityCard } from "../activity-card";

export type EnrichedActivity = {
  activity: {
    id: string;
    name: string;
    metric: string;
    iconKey: string;
    levels: readonly { score: number; label: string; sublabel?: string }[];
  };
  skill: { skillLevel: number; activityId: string } | undefined;
  level: { score: number; label: string; sublabel?: string } | undefined;
};

type ActivitySelectorProps = {
  activities: EnrichedActivity[];
  onSelect: (activityId: string) => void;
  isLoading?: boolean;
};

export function ActivitySelector({
  activities,
  onSelect,
  isLoading = false,
}: ActivitySelectorProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-20 animate-pulse rounded-xl bg-surface-alt/80"
          />
        ))}
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="rounded-2xl border border-border bg-surface-alt/80 p-4 text-center text-text-secondary">
        They haven't added any activities yet.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {activities.map((entry) => {
        const { activity, level } = entry;
        return (
          <ActivityCard
            key={activity.id}
            activitySkill={{
              activityId: activity.id,
              activity,
              level: level || null,
            }}
            isSelected={false}
            onSelect={() => onSelect(activity.id)}
            showSelectionIndicator={false}
          />
        );
      })}
    </div>
  );
}
